// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"4af4edbc","875":"b37fad64"}[chunkId] + ".chunk.js";
};